module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_bg_1.1ee9e35d.png";